import { createReduxActionCreator } from '../types';

export const ACTION_PREFIX = 'payment-redux/';

export const getTransactionAmountActions = createReduxActionCreator<string>(`${ACTION_PREFIX}get-transaction-amount`);
